<template>
  <div class="container">
    <v-expansion-panels>
      <v-expansion-panel isActive="true">
        <v-expansion-panel-header>
            Φίλτρα αναζήτησης
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="documentIssueDateStartFilter"
                          label="Ημερομηνία (Από)"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable>
                      </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="documentIssueDateStartFilter"
                      @input="menu1 = false">
                  </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="documentIssueDateStopFilter"
                            label="Ημερομηνία (Έως)"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="documentIssueDateStopFilter"
                        @input="menu2 = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
          </v-row>
        <v-row>
            <v-col cols="12" sm="6">
              <v-select 
                    v-bind:items="invoiceStatusValues"
                    item-text="name"
                    item-value="id"

                    v-model="invoiceStatus"

                    type="text"
                    label="Κατάσταση τιμολόγησης"
                    clearable>
                </v-select>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field 
                    v-model="supplierFilterValue"
                    type="text"
                    label="Προμηθευτής"
                    clearable>
                </v-text-field>
                
            </v-col>
            
        </v-row>

          <v-row class="my-2" cols="12" align="center" justify="center">
            <v-btn 
                class="mx-2"
                color="success" 
                @click="getData" 
                v-bind:loading="getDataButtonDisabled"
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn 
                class="mx-2"
                color="warning" 
                @click="clearFilters" 
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>

        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

    <v-data-table
      :headers="headers"
      :items="items"
      :sort-by="['date']"
      :sort-desc="true"
      class="elevation-1 my-2"
      disable-filtering>
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Αποτελέσματα</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          
          <v-spacer></v-spacer>
          <v-btn color="success" dark class="mb-2" @click="excelPlease" v-show="showExport" v-bind:loading="getExcelButtonDisabled">
            ΕΞΑΓΩΓΗ
          </v-btn>

        </v-toolbar>
      </template>
      
      <template v-slot:[`item.date`]="{ item }">
        {{ formatDate(item.date) }}
      </template>

      <template slot="body.append" v-if="showExport">
        <tr>
            <th>Σύνολα</th>
            <th></th>
            <th></th>
            <th class="text-right">{{totalsSum('quantity', 2)}}</th>
            
        </tr>
      </template>



    </v-data-table>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: () => ({
      invoiceStatusValues: [
        { id: -1, name: 'Ανεξάρτητα'},
        { id: 0, name: 'Εκκρεμείς'},
        { id: 1, name: 'Τιμολογημένες'},
      ],

      allerrors : {
        
      },

      dialog: false,

      headers: [
        {
          text: 'Προμηθευτής',
          align: 'start',
          value: 'supplier',
        },
        { 
          text: 'Κωδικός', 
          align: 'left',
          value: 'code' 
        },
        { 
          text: 'Είδος', 
          align: 'left',
          value: 'description' 
        },
        { 
          text: 'Ποσότητα', 
          align: 'right',
          value: 'quantity',
          exportTransformer: (cell) => cell.replace('.', ',')  
        },
      ],

      items: [],


      documentTypes: [],
      accounts: [],

      selectedAccount: {},

      documentTypeFilter: null,

      documentIssueDateStartFilter: null,
      documentIssueDateStopFilter: null,

      supplierFilterValue: null,

      getDataButtonDisabled: false,
      getExcelButtonDisabled: false,

      menu2: null,
      menu1: null,

      invoiceStatus: 0,


    }),

    watch: {

    },

    created () {
      this.initialize()
    },

    computed: {
      showExport() {
        return this.items?.length > 0
      }
    },

    methods: {

      totalsSum(fieldName, fixDecimals) {
        const sum = this.items?.map(x => parseFloat(x[fieldName])).reduce((a, b) => a + b, 0)

        if (fixDecimals > 0)
          return sum.toFixed(2)

        return parseInt(sum)
      },

      excelPlease() {
        if (this.items?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.items.map(line => transform(line, columnDefinitions))
        }

        this.axiosDownload('/api/test', requestBody, 'αναφορά.xls')
      },

      axiosDownload(url, requestBody, filename) {
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.getExcelButtonDisabled = false
        // link.remove();
        // url.remove();

        }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
      },

      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      formatMoney(amount) {
        if (amount == null)
          amount = 0.0

        return amount.toFixed(2)
      },


      initialize () {
        this.$store.dispatch('currentUser/getCurrentUser')
        
        const initialDaysBeforeFilterValue = 30

        const today = new Date();

        let filterStart = new Date()
        filterStart.setDate(today.getDate() - initialDaysBeforeFilterValue);

        this.documentIssueDateStartFilter = this.$localDateString(filterStart)
        this.documentIssueDateStopFilter = this.$localDateString(today)

        

        // this.getData();
        this.getFilterValues()
      },

      getFilterValues() {
        // this.accounts = axios.get('/api/accounts')
        //     .then(response => {
        //         this.accounts = response.data
        //     }).catch(error => console.log(error))
      },
      
      getRequestParams() {
        let out = {
          supplier: null,
          invoice_status: -1
        }


        if (this.documentIssueDateStartFilter != null)
          out.issue_date_start = this.documentIssueDateStartFilter

        if (this.documentIssueDateStopFilter != null)
          out.issue_date_stop = this.documentIssueDateStopFilter

        if (this.supplierFilterValue?.length > 0)
          out.supplier = this.supplierFilterValue

        if (this.invoiceStatus != null)
          out.invoice_status = this.invoiceStatus
        
        return out
      },

      getData() {
        this.allerrors = {}

        const params = this.getRequestParams()

        if (params.issue_date_start == null || params.issue_date_stop == null)
          return


        this.getDataButtonDisabled = true;
        axios.post(
            '/api/reports/order-sums-per-supplier', 
            {
                params: params
            }
        )
        .then(response => this.items = response.data)
        .finally(() => { this.getDataButtonDisabled = false; })
        .catch(error => { 
          if (error.response.data)
              this.allerrors = error.response.data.errors
         })
        
      },


      clearFilters() {
        this.documentIssueDateStartFilter = null
        this.documentIssueDateStopFilter = null
      }
    }
  }
</script>

<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}
</style>